export default __webpack_public_path__ + "static/media/logo-snm-big.22d5c710.png";